import NavigationController from './list/list_controller';

const NavigationApp = {
  start(options) {
    return new NavigationController(options);
  }
};

export default NavigationApp;
